import { organisationConstants } from '../../../_constants/organisation.constants';

const initialState = { check_bulk_download_loading : true, check_bulk_download: null, check_bulk_download_error: false};

export function checkBulkDownloadReducer(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_CHECK_BULK_DOWNLOAD_API:
        return {
            check_bulk_download_loading: true,
            check_bulk_download: null,
            check_bulk_download_error: false
        };
      case organisationConstants.RECIEVE_CHECK_BULK_DOWNLOAD_API:
        return {
            check_bulk_download_loading: false,
            check_bulk_download: action.bulkDownload,
            check_bulk_download_error: false
        };
      case organisationConstants.ERROR_CHECK_BULK_DOWNLOAD_API:
        return { 
            check_bulk_download_loading: false,
            check_bulk_download: null,
            check_bulk_download_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/bulkDownload/checkBulkDownload.js